import { memo } from 'react';
import { useFormikContext } from 'formik';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';
import Deceased from 'front-office/components/shared/deceased';
import { Grid, useEventCallback } from '@mui/material';
import { DecasedFormVM } from 'front-office/view-models/certificate/deceased-form';
import Will from '../will';
import { WillFormVM } from 'front-office/view-models/certificate/will-form';

const DeceasedWithWillComponent = (): React.ReactElement => {
  const formContext = useFormikContext<StatementsFormVM>();

  const onFieldDecasedChange = useEventCallback(
    (key: keyof DecasedFormVM, value: DecasedFormVM[keyof DecasedFormVM]) => {
      formContext.setFieldValue('decased', {
        ...formContext.values.decased,
        [key]: value,
      });
    }
  );

  const onFieldWillChange = useEventCallback(
    (key: keyof WillFormVM, value: WillFormVM[keyof WillFormVM]) => {
      formContext.setFieldValue('will', {
        ...formContext.values.will,
        [key]: value,
      });
    }
  );

  const onFieldsDeceasedChange = useEventCallback((values: DecasedFormVM) => {
    formContext.setFieldValue('decased', {
      ...formContext.values.decased,
      ...values,
    });
  });

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <Deceased
          onFieldDecasedChange={onFieldDecasedChange}
          decased={formContext.values.decased}
          onFieldsDeceasedChange={onFieldsDeceasedChange}
        />
      </Grid>
      <Grid item xs={12}>
        <Will will={formContext.values.will} onFieldWillChange={onFieldWillChange} />
      </Grid>
    </Grid>
  );
};

DeceasedWithWillComponent.displayName = 'Deceased With Will component';

const DeceasedWithWill = memo(DeceasedWithWillComponent);

export default DeceasedWithWill;
